import { Henshu } from '../../henshu';

import App from './App';
import store from './store';
import firebaseConfig from './firebaseConfig';


export default function Skin() {
    return (
        <Henshu firebaseConfig={firebaseConfig} store={store}>
            <App />
        </Henshu>
    );
}
